import { getEnvConfig } from '@vs/utils/envConfig';

import { deployEnv } from '..';

export const env = getEnvConfig({
  deployEnv,
  hosts: {
    vsApp: import.meta.env.VITE_HOST_VS_APP,
    vsAdminApp: import.meta.env.VITE_HOST_VS_ADMIN_APP,
    vsApi: import.meta.env.VITE_HOST_VS_API,
    vsSsoApi: import.meta.env.VITE_HOST_VS_SSO_API,
    vsAsset: import.meta.env.VITE_HOST_VS_ASSET,
  },
});
